import { render, staticRenderFns } from "./DetailClient.vue?vue&type=template&id=ffe98ee4&scoped=true&"
import script from "./DetailClient.vue?vue&type=script&lang=js&"
export * from "./DetailClient.vue?vue&type=script&lang=js&"
import style0 from "./DetailClient.vue?vue&type=style&index=0&id=ffe98ee4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffe98ee4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCard,VIcon,VTab,VTabs,VTabsItems})
